export default "__VITE_ASSET__BBWIAPLp__"